module.exports = __webpack_public_path__ + "assets/img/block-left-hover-e16877ff.png";